'serviceWorker' in navigator && window.addEventListener('load', function() {

	var params = {};
	var urlParams = '';

	params.locale = Lang.getLocale();
	params.release = Laravel.release;

	params.offlinePage = route('offline.' + params.locale, {}, false).toString();
	params.rechercheResult = route('front.resultats-recherche.' + params.locale, {}, false).toString();
	params.bonsplansTroc = route('bons-plans.' + params.locale, {}, false).toString();
	params.selectionTroc = route('selection-troc.' + params.locale, {}, false).toString();

	Object.keys(params).map(function(objectKey) {

	    urlParams += (urlParams ? '&' : '?') + objectKey + '=' + encodeURIComponent(params[objectKey]);
	});

	navigator.serviceWorker.register('/service-worker.js' + urlParams).then(function() {

		//console.log('TrocPWA service worker ready');

	}).catch(function(e) {

		//console.log('Registration failed with ' + e);
	});
});
